@if (inspectionReportGroup().group.groupInfo.isGrouped) {
  <gc-accordion [expanded]="expandAccordion()">
    <ng-template #gcAccordionHeader>
      <div class="accordion-header">
        @if (!isDeviation()) {
          <gc-icon
            [iconName]="isAllComplete() ? 'circleCheck' : 'circleClose'"
            [color]="isAllComplete() ? 'success' : 'primary'"
          />
        } @else if (isAllComplete()) {
          <gc-icon [iconName]="'triangleExclamation'" [color]="'critical'" />
        }
        <gc-text>
          {{ accordionHeader() }}
        </gc-text>
      </div>
    </ng-template>
    <ng-template #gcAccordionBody>
      <ng-container *ngTemplateOutlet="selfInspections" />
    </ng-template>
  </gc-accordion>
} @else {
  <ng-container *ngTemplateOutlet="selfInspections" />
}

<ng-template #selfInspections>
  <div class="accordion-body">
    @for (inspection of inspectionReportGroup().selfInspections; track $index) {
      @switch (inspection.definition.type) {
        @case (definitionTypes.TEXT) {
          <app-self-inspection-text
            [data]="reportAnswers()[$index].data"
            [wrapperData]="reportAnswers()[$index].wrapperData"
            (saveTextInput)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (markAsNA)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (undoSelfInspection)="
              undoSelfInpseciton(
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
          />
        }
        @case (definitionTypes.RADIOBUTTON) {
          <app-self-inspection-radio-button
            [data]="reportAnswers()[$index].data"
            [wrapperData]="reportAnswers()[$index].wrapperData"
            (checkedValue)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (markAsNA)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (undoSelfInspection)="
              undoSelfInpseciton(
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
          />
        }
        @case (definitionTypes.CHECKBOX) {
          <app-self-inspection-checkbox
            [data]="reportAnswers()[$index].data"
            [wrapperData]="reportAnswers()[$index].wrapperData"
            (markAsDone)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (markAsNA)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (undoSelfInspection)="
              undoSelfInpseciton(
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
          />
        }
        @case (definitionTypes.LIST) {
          <app-self-inspection-list
            [data]="reportAnswers()[$index].data"
            [wrapperData]="reportAnswers()[$index].wrapperData"
            (saveInputs)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (markAsNA)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
          />
        }
        @case (definitionTypes.FILES) {
          <app-self-inspection-files
            [data]="reportAnswers()[$index].data"
            [wrapperData]="reportAnswers()[$index].wrapperData"
            [isDeviation]="isDeviation()"
            (viewImages)="
              openImagePreview(
                reportAnswers()[$index].data,
                reportId,
                reportGroup(),
                false
              )
            "
            (uploadFiles)="
              saveFile(
                $event,
                inspection.definition,
                reportId,
                reportGroup(),
                false
              )
            "
            (markAsNA)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (undoSelfInspection)="
              undoSelfInpseciton(
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (fileDelete)="
              deleteFile(
                inspection.definition.id,
                $event,
                reportId,
                reportGroup()
              )
            "
            (filesDownload)="downloadFiles($event)"
          />
        }
        @case (definitionTypes.FILE_AND_TEXT) {
          <app-self-inspection-file-and-text
            [data]="reportAnswers()[$index].data"
            [wrapperData]="reportAnswers()[$index].wrapperData"
            (viewImages)="
              openImagePreview(
                reportAnswers()[$index].data,
                reportId,
                reportGroup(),
                true
              )
            "
            (uploadFiles)="
              saveFile(
                $event,
                inspection.definition,
                reportId,
                reportGroup(),
                true
              )
            "
            (saveTextInput)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (markAsNA)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (undoSelfInspection)="
              undoSelfInpseciton(
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (fileDelete)="
              deleteFile(
                inspection.definition.id,
                $event,
                reportId,
                reportGroup()
              )
            "
            (filesDownload)="downloadFiles($event)"
          />
        }
        @case (definitionTypes.TEXT_AREA) {
          <app-self-inspection-text
            [data]="reportAnswers()[$index].data"
            [wrapperData]="reportAnswers()[$index].wrapperData"
            [canBeMarkedNotApplicable]="!isDeviation()"
            (saveTextInput)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (markAsNA)="
              saveAnswer(
                $event,
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
            (undoSelfInspection)="
              undoSelfInpseciton(
                inspection.definition.id,
                reportId,
                reportGroup()
              )
            "
          />
        }
      }
    }
  </div>
</ng-template>
